import { ResourceSQL } from "../resource-sql/resource-sql.model";

export class ContactPreference extends ResourceSQL {
  masterPreferenceId: string;
  value: string;
  emailAddress: string;
  tenantId: string;
  channels: string;
  frequencies: string;
  source: string;

  /*constructor() {
    super();
    this.masterPreferenceId = '';
    this.value = '';
    this.emailAddress = '';
  }*/
}